import React from "react";
import "./ThinkingIndicator.css";

export default function ThinkingIndicator({ label }) {
  return (
    <div className="thinking-indicator">
      <span className="thinking-dot" data-testid="thinking-dot" />
      <span className="thinking-dot" data-testid="thinking-dot" />
      <span className="thinking-dot" data-testid="thinking-dot" />
      <span className="thinking-label">{label ?? "Thinking\u2026"}</span>
    </div>
  );
}
